<!--
   Created by qing on 2020/9/9
   Des: 
-->
<template>
  <van-action-sheet
    class="approval-comment-container"
    v-model="visible"
    @close="beforeClose"
    title="确认提交？">

    <template v-if="showComment">
      <div class="comment-header" @click="commentVisible = true">
        点击选择常用审批意见
      </div>
      <van-field
        rows="3"
        type="textarea"
        v-model="comment"
        placeholder="请输入审批意见">
      </van-field>
    </template>


    <p v-if="showSignature">手写签名</p>

    <template v-if="init && showSignature">
      <div v-if="!signatureUrl">
        <div class="add-sign-btn" v-if="!lastSignInfo || !lastSignInfo.hasSignature" @click="addSign">
          <i class="iconfont icon-signature"></i>
          <span>添加签名</span>
        </div>
        <div class="last-sign-container">
          <div class="signature-wrapper" v-if="lastSignInfo && lastSignInfo.signatureUrl">
            <el-image class="last-sign-image" :src="lastSignInfo.signatureUrl"></el-image>

            <div class="footer">
              <van-button type="default" size="small" @click="rewriteSign">重新手写</van-button>
              <van-button type="primary" size="small" @click="useLastSign">使用</van-button>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="sign-show-container">
        <el-image class="sign-image" v-if="signatureUrl" :src="signatureUrl"></el-image>
        <el-button type="text" icon="el-icon-delete" @click.stop="deleteSign"></el-button>
      </div>
    </template>

    <div class="bottom-handle">
      <van-button type="default" @click="visible = false">取消</van-button>
      <van-button type="primary" @click="confirm">确定</van-button>
    </div>

    <SignPopup ref="signPopup" @signSuccess="signSuccess" @signCancel="signCancel"></SignPopup>

    <van-action-sheet
      v-model="commentVisible"
      :actions="opts"
      get-container="body"
      title="选择常用审批意见"
      cancel-text="取消"
      @select="onSelect">
    </van-action-sheet>
  </van-action-sheet>
</template>

<script>
  import SignPopup from "../component/sign_widget/SignPopup";
  export default {
    data() {
      return {
        visible: false,
        commentVisible: false,
        init: false,
        companyId: '',
        appId: '',
        formId: '',
        originName: '', // 操作类型
        taskId: '', // 轮训ID
        qrCodeUrl: '',
        signatureUrl: '', // 签名url
        comment: '', // 审批意见
        lastSignInfo: null, // 已保存签名信息
        timer: null,
        enableComment: 0,
        enableSignature: 0, // 是否打开签名
        commentList: [],
        signKey: '',

        rejectCloseComment: 0, //拒绝时可以不填意见
        rejectCloseSignature: 0, //拒绝时可以不填签名

        showComment: true, // 展示意见
        showSignature: true, // 展示签名
        enableEmptyComment: false, // 意见可以为空
        enableEmptySignature: false, // 签名可以为空
      }
    },
    components: {SignPopup},
    created() {
    },
    computed: {
      opts() {
        const copyCommentList = []
        this.commentList.forEach(s => {
          copyCommentList.push({
            name: s,
            value: s
          })
        })
        return copyCommentList
      },
    },
    methods: {

      open({companyId, appId, formId, showComment, showSignature, originName, enableEmptyComment, enableEmptySignature}) {
        this.comment = ''
        this.signatureUrl = ''
        this.lastSignInfo = null
        this.init = false
        this.showComment = showComment
        this.showSignature = showSignature
        this.enableEmptyComment = enableEmptyComment
        this.enableEmptySignature = enableEmptySignature
        this.originName = originName
        this.visible = true
        this.companyId = companyId
        this.appId = appId
        this.formId = formId

        this.$store.dispatch('actionFormLastSignatureGet')
          .then(res => {
            this.lastSignInfo = res
            this.createQrCodeUrl()
          })
          .catch(console.error)

        this.$store.dispatch('actionFetchUserDefaultReply')
          .then(res => {
            this.commentList = res
          }).catch(console.error)
      },
      onSelect(item) {
        this.comment = item.value
        this.commentVisible = false
      },

      createQrCodeUrl(callback) {

       this.$store.dispatch('actionApprovalCommentKey', {
          cycleType: 'SIGNATURE'
        })
          .then(res => {
            this.taskId = res.taskId
            return this.$store.dispatch('actionNodeSave', {
              userId: this.$store.getters.userId,
              companyId: this.companyId,
              appId: this.appId,
              formId: this.formId,
              taskId: res.taskId
            })
          })
          .then(res => {
            this.signKey = res.nodeKey
            if (callback) {
              callback()
            }
          })
          .then(() => {
            if (!this.lastSignInfo || !this.lastSignInfo.hasSignature) {
              this.timer = setTimeout(() => {
                this.getSignResult()
              }, 2000)
            }
          })
          .catch(console.error)
          .finally(() => {
            this.init = true
          })
      },

      getSignResult() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        if (!this.visible) {
          return
        }
        this.$store.dispatch('actionApprovalCommentSignResult', {
          taskId: this.taskId
        }).then(res => {
          if (res.executeFinish) {
            this.signatureUrl = res.resultInfo.signatureUrl
          } else {
            this.timer = setTimeout(() => {
              this.getSignResult()
            }, 2000)
          }
        }).catch(console.error)
      },
      beforeClose() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      },

      // 添加签名
      addSign() {
        if (!this.lastSignInfo || !this.lastSignInfo.hasSignature) {
          if (this.$refs.signPopup) {
            this.createQrCodeUrl(() => {
              this.$refs.signPopup.open(this.signKey)
            })
          }
        }
      },
      // 使用上次签名
      useLastSign() {
        this.signatureUrl = this.lastSignInfo.signatureUrl
      },

      // 重新签名
      rewriteSign() {
        this.lastSignInfo.hasSignature = 0
        this.lastSignInfo.signatureUrl = ''
      },

      // 删除签名
      deleteSign() {
        this.signatureUrl = ''
      },

      // 预览签名
      previewImage(e) {
        const ele = e.target.parentNode.firstChild
        if (ele) ele.click()
      },

      signCancel() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      },

      signSuccess() {
        if (this.$refs.signPopup) {
          this.$refs.signPopup.close()
        }
      },

      confirm() {

        // if (this.originName === 'reject') {
        //   if (this.enableComment && !this.rejectCloseComment && !this.comment) {
        //     this.$toast.fail('请填写审批意见')
        //     return
        //   }
        //   if (this.enableSignature && !this.rejectCloseSignature && !this.signatureUrl) {
        //     this.$toast.fail('手写签名是必填项，请签名')
        //     return
        //   }
        // } else {
        //   if (this.enableComment && !this.comment) {
        //     this.$toast.fail('请填写审批意见')
        //     return
        //   }
        //   if (this.enableSignature && !this.signatureUrl) {
        //     this.$toast.fail('手写签名是必填项，请签名')
        //     return
        //   }
        // }

        if (this.showComment && !this.enableEmptyComment && !this.comment) {
          this.$toast.fail('请填写审批意见')
          return
        }
        if (this.showSignature && !this.enableEmptySignature && !this.signatureUrl) {
          this.$toast.fail('手写签名是必填项，请签名')
          return
        }

        this.$emit('commentComplete', {
          originName: this.originName,
          comment: this.comment,
          signatureUrl: this.signatureUrl
        })
      }
    }
  }
</script>

<style lang="less">

  .approval-comment-container {

    .comment-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      margin-left: 10px;
      color: #3a8ee6;
      font-size: 14px;
    }

    p {
      font-size: 12px;
      margin: 10px;
    }

    .van-field {
      width: calc(100% - 20px);
      border: 1px solid #e6e6e6;
      margin: 0 10px;
    }

    .add-sign-btn {
      width: calc(100% - 20px);
      margin: 0 10px;
      height: 34px;
      border: 1px solid #e6e6e6;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      cursor: pointer;

      i {
        margin-right: 10px;
        color: #2D8cF0;
      }
    }

    .sign-show-container {
      width: 100%;
      height: 60px;
      border: 1px solid #e6e6e6;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      position: relative;

      .el-image {
        width: 100px;
        height: 59px;
      }

      .el-button {
        position: absolute;
        right: 40px;
        color: red;
      }
    }

    .last-sign-container {
      .signature-wrapper {
        width: calc(100% - 20px);
        min-height: 140px;
        margin: 10px;
        padding: 10px;
        text-align: center;
        border: 1px solid #D9D9D9;
        border-radius: 3px;
        display: flex;
        align-items: center;
        position: relative;

        .el-image {
          width: 50%;
          height: auto;
          margin-left: 20px;
        }

        .footer {
          height: 100%;
          margin-top: 0;
          position: absolute;
          right: 10px;
          display: flex;
          flex-direction: column;

          .van-button {
            width: 80px;
            margin-top: 10px;
          }
        }
      }
    }

    .bottom-handle {
      height: 44px;
      margin-top: 40px;

      .van-button {
        width: 50%;
      }
    }
  }
</style>